module.exports = __webpack_public_path__ + "static/fonts/LT_21024.64f5ab78.ttf";